export const PLATFORM = {
  ANDROID: "android",
  IOS: "ios",
  DESKTOP: "desktop"
};

export function getPlatform() {
  if (typeof navigator === "undefined") return PLATFORM.DESKTOP;

  const userAgent = navigator.userAgent || navigator.vendor || "";
  const platform = navigator.platform || "";
  const isTouchMac = platform === "MacIntel" && navigator.maxTouchPoints > 1;
  const isDesktopPlatform = /Win|Linux x86_64|Linux i686/i.test(platform) || (/Mac/i.test(platform) && !isTouchMac);

  if (isDesktopPlatform) return PLATFORM.DESKTOP;
  if (/Android/i.test(userAgent)) return PLATFORM.ANDROID;
  if (/iPad|iPhone|iPod/i.test(userAgent) || isTouchMac) return PLATFORM.IOS;

  return PLATFORM.DESKTOP;
}
